import { FC, useEffect } from 'react';

import { getSelectedEmails, getSelectedNamedEmails } from '@features/emailsSlice';
import useTranslateEmails from '@hooks/useTranslateEmails';
import NewOrderBase from '@routes/NewOrder/NewOrderBase';
import { ROUTES } from '@routes/constants';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const NewOrderEmails: FC = () => {
  const selectedEmails = useSelector(getSelectedEmails);
  const namedSelected = useSelector(getSelectedNamedEmails);
  const { mutateAsync, isLoading, error, isError, reset } = useTranslateEmails();
  const navigate = useNavigate();

  useEffect(() => {
    if (!selectedEmails || !selectedEmails.length) navigate(ROUTES.EMAILS);
  }, [selectedEmails, navigate]);

  return (
    <NewOrderBase
      type={'emails'}
      mutationError={error}
      mutationIsError={isError}
      mutationIsLoading={isLoading}
      mutationReset={reset}
      selected={selectedEmails}
      onSend={(data) => mutateAsync({ ...data, ids: selectedEmails })}
      namedSelected={namedSelected}
    />
  );
};

export default NewOrderEmails;
